import DuiNotificationManager from './dui-notification-manager/dui-notification-manager';
import DuiPageGuardManager from './dui-page-guard-manager/dui-page-guard-manager';
import DuiUniqueInstanceManager from './dui-unique-instance-manager/dui-unique-instance-manager';

export default [
  DuiNotificationManager,
  DuiPageGuardManager,
  DuiUniqueInstanceManager,
];
